import moment from 'moment'
import APIService from '@/api'

export default class APIContract extends APIService{

    constructor(){
        super('contracts')
    }

    async search(filters) {
      var response = await this.AxiosInstance
          .post(this.ApiUrl + "/search", filters, {})
          .catch(error => {
            console.log(error.response)
          });
      return response;
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    get(id) {
        var response = this.AxiosInstance
            .get(this.ApiUrl + "/" + id, {})
            .catch(error => {
                console.log(error.response)
            });
        return response;
    }

    async getCountForPostTransmission() {
        var response = this.AxiosInstance
            .get(this.ApiUrl + "/countForPostTransmission", {})
            .catch(error => {
                console.log(error.response)
            });
        return response;
    }

    create(item) {
        return this.AxiosInstance.post(this.ApiUrl, item, {});
    }

    update(item) {
        return this.AxiosInstance.put(this.ApiUrl + "/" + item.ID, item, {});
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl + "/" + item.ID, {});
    }

    sendContractByEmail(id) {
        return this.AxiosInstance.post(this.ApiUrl + "/sendcontractbyemail/" + id, {});
    }
}



// WEBPACK FOOTER //
// ./src/api/contract.js